<template>
  <div>
    <div class="flex justify-between items-center mb-4">
      <div class="flex items-center">
        <h5><i class="dot"></i>{{ $t("⑨ 일일TBM 활동 현황") }}</h5>
        <div v-if="!isPrint" class="inline-block flex items-center cursor-pointer" @click="showPopup = true">
          <feather-icon icon="AlertCircleIcon" class="ml-6 mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />
          <span style="color: #7e72f2">{{ $t("TBM순서") }}</span>
        </div>
      </div>
      <!-- https://app.clickup.com/t/86ep5bb9n 요청에 의해 삭제 : TODO = 86ep5bb9n -->
      <!--      <div v-if="!readonly && !isPrint">-->
      <!--        <vs-button color="secondary" type="border" @click="handleAddRow">{{ $t('항목추가') }}</vs-button>-->
      <!--        <vs-button class="ml-4" color="secondary" @click="handleRemoveRow">{{ $t('선택삭제') }}</vs-button>-->
      <!--      </div>-->
    </div>

    <table v-if="isPrint">
      <colgroup>
        <col style="width: 50.02%" />
        <col style="width: 16.66%" />
        <col style="width: 16.66%" />
        <col style="width: 16.66%" />
      </colgroup>
      <thead>
        <th>{{ $t("TBM활동 내용") }}</th>
        <th>{{ $t("참석인원(전일까지)") }}</th>
        <th>{{ $t("참석인원(금일)") }}</th>
        <th>{{ $t("참석인원(누계)") }}</th>
      </thead>
      <tbody>
        <tr v-for="(item, item_i) in list" :key="item.id">
          <td>
            <div class="print-input">{{ item.input1 }}</div>
          </td>
          <td>
            <div class="print-input">{{ prev }}</div>
          </td>
          <td>
            <div class="print-input">{{ item.input3 }}</div>
          </td>
          <td>
            <div class="print-input">{{ total }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else class="overflow-x-auto">
      <table style="min-width: 1100px">
        <colgroup>
          <col style="width: 50.02%" />
          <col style="width: 16.66%" />
          <col style="width: 16.66%" />
          <col style="width: 16.66%" />
        </colgroup>
        <thead>
          <th>{{ $t("TBM활동 내용") }}</th>
          <th>{{ $t("참석인원(전일까지)") }}</th>
          <th>{{ $t("참석인원(금일)") }}</th>
          <th>{{ $t("참석인원(누계)") }}</th>
        </thead>
        <tbody>
          <tr v-for="(item, item_i) in list" :key="item.id">
            <td>
              <ml-input v-model="item.input1" style="background-color: #fafafa" :readonly="readonly" class="hidden xl:block" />
              <ml-textarea :readonly="readonly" v-model="item.input1" :rows="2"  class="block xl:hidden" />
            </td>
            <td><comma-input readonly :value="prev" class="w-full" :placeholder="$t('자동(전일까지누계 합산)')" /></td>
            <td><comma-input :readonly="readonly" v-model="item.input3" class="w-full" :placeholder="$t('숫자입력')" /></td>
            <td><comma-input readonly :value="total" class="w-full" :placeholder="$t('자동(전일누계 + 금일)')" /></td>
          </tr>
        </tbody>
      </table>
    </div>

    <vs-popup :title="$t('TBM순서')" :active.sync="showPopup">
      <table>
        <colgroup>
          <col width="70" />
        </colgroup>
        <thead>
          <th>{{ $t("순서") }}</th>
          <th colspan="2">{{ $t("내용") }}</th>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center">1</td>
            <td style="text-align: center">{{ $t("집합·인사") }}</td>
            <td>{{ $t("직원, TBM리더, 팀원") }}</td>
          </tr>
          <tr>
            <td style="text-align: center">2</td>
            <td style="text-align: center">{{ $t("보호구확인") }}</td>
            <td>{{ $t("리더→팀원, 팀원간") }}</td>
          </tr>
          <tr>
            <td style="text-align: center">3</td>
            <td style="text-align: center">{{ $t("당일작업 및 위험사항 전달") }}</td>
            <td>{{ $t("전원참여. 위험예지") }}</td>
          </tr>
          <tr>
            <td style="text-align: center">4</td>
            <td style="text-align: center">{{ $t("기타사항 전파") }}</td>
            <td>{{ $t("전파원청사 직원, 리더") }}</td>
          </tr>
          <tr>
            <td style="text-align: center">5</td>
            <td style="text-align: center">{{ $t("지적확인") }}</td>
            <td>{{ $t("모든팀원 3회 복창") }}</td>
          </tr>
        </tbody>
      </table></vs-popup
    >
  </div>
</template>

<script>
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    DisasterClassSelector,
    DateSelector,
  },
  props: {
    readonly: { type: Boolean, default: false },
    isPrint: { type: Boolean, default: false },
    value: {
      type: Array,
      default: () => [
        {
          input1: "기타",
          input1_1: "",
          input2: "",
          input3: "",
          input4: "",
        },
      ],
    },
    prevTmbOption: { type: Array, default: () => [] },
    todayTmbOption: { type: Array, default: () => [] },
  },
  data() {
    return {
      showPopup: false,
      checkData: [],
      list: [
        {
          input1: "",
          input1_1: "",
          input2: "",
          input3: "",
          input4: "",
        },
      ],
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
    };
  },
  computed: {
    // 사용한 option은 제외시킨다
    optionFilter() {
      return [
        { type: "직접입력 (예시 : 자재 입고에 따른 지게차 이동동선 및 작업구역 설정 확보 철저)", value: "직접입력" },
        { type: "집합·인사", value: "집합·인사" },
        { type: "보호구확인", value: "보호구확인" },
        { type: "당일작업 및 위험사항 전달", value: "당일작업 및 위험사항 전달" },
        { type: "기타사항 전파", value: "기타사항 전파" },
        { type: "지적확인", value: "지적확인" },
        { type: "기타", value: "기타" },
      ];
      // const useType = this.value
      //   .map((_v) => {
      //     return _v.input1;
      //   })
      //   .filter((v) => v !== "기타");
      // return this.prevTmbOption.filter((option) => !useType.includes(option.type));
    },

    prev() {
      if (this.prevTmbOption && this.prevTmbOption.length > 0) {
        let prev = 0;
        for (const prevData of this.prevTmbOption) {
          if (prevData && prevData.value) {
            prev += Number(`${prevData.value}`);
          }
        }
        return prev;
      }
      return 0;
    },

    total() {
      // 86ep5bb9n 요청에 의해, list 가 1개로 제한 됨
      if (this.list && this.list.length > 0) {
        const data = this.list[0];
        let total = Number(this.prev || 0) + Number(data.input3 || 0);
        if (this.todayTmbOption && this.todayTmbOption.length > 0) {
          for (const todayData of this.todayTmbOption) {
            if (todayData && todayData.value) {
              total += Number(`${todayData.value}`);
            }
          }
        }
        return total;
      }

      return 0;
    },
  },
  watch: {
    value: {
      handler(value) {
        if (value && value.length > 0) {
          this.list = value;
          this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
        } else {
          this.list = [
            {
              input1: "",
              input1_1: "",
              input2: "",
              input3: "",
              input4: "",
            },
          ];
        }
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // All 체크박스 클릭
    onClickAllCheck() {
      if (this.checkData.length === this.list.length) this.checkData = [];
      else this.checkData = this.list.map((item) => item.id);
    },
    // 항목추가
    handleAddRow() {
      const addData = { id: ++this.numberId, input1: "" };
      this.list.push(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 5px;

    &::v-deep .con-vs-checkbox {
      justify-content: center !important;
      margin: 0;
      span {
        margin: 0;
      }
    }
    &::v-deep .con-vs-radio {
      width: 100%;
      justify-content: center !important;
    }
  }
  th {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;

    background: #f9f9f9;
    padding: 21px 7px;
  }
}

.disaster::v-deep {
  .con-select {
    width: 100%;
  }
}
</style>
